/**
 * 与静泉 H5 PayChannel 枚举一致（节选）。
 * @see qkl/20260605_114922/jingquan_client.py
 */
export const PayChannel = {
    SAND_PAY: 20,
    YEE_PAY: 22,
    YEE_WALLET: 23,
    SAND_WALLET: 24,
    /** 积分/余额钱包 */
    POINT_WALLET: 27,
    GLOBAL_PAY_WALLET: 32,
    /** 江融服（官网寄售「其他支付」，getGoodsPoundage payChannel=45） */
    JIANG_RONG_FU: 45
};

/** 镜权平台默认支付渠道（易宝钱包 23，与 getGoodsPoundage / 已付订单 payChannel 一致） */
export const JQ18_DEFAULT_PAY_CHANNEL = PayChannel.YEE_WALLET;

/** 镜权寄售收款：官网有多渠道时默认全部选中（易宝 + 江融服等） */
export const JQ18_DEFAULT_RESELL_RECEIVE_CHANNEL = PayChannel.JIANG_RONG_FU;

/** 余额/积分钱包（需 checkConsignPass → resaleUuId） */
export function isBalancePayChannel(payChannel) {
    return Number(payChannel) === PayChannel.POINT_WALLET;
}

/** 易宝直连 / 易宝钱包（orderPay 直调，外链收银台时打开浏览器） */
export function isYeepayPayChannel(payChannel) {
    const n = Number(payChannel);
    return n === PayChannel.YEE_PAY || n === PayChannel.YEE_WALLET;
}
